import * as React from 'react'
import { styled } from 'next-yak'

import * as fonts from '../../../constants/fonts'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'

export * from './Caret'
export * from './House'
export * from './Percent'
export * from './Plus'
export * from './Stack3d'
export * from './Audio'
export * from './Image'
export * from './Text'
export * from './Video'

export const Alert = styled(function Alert(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="alert">
      <g>
        <path
          d="M18 17.058C18 18.131 17.105 19 16 19s-2-.87-2-1.942V8.942C14 7.869 14.895 7 16 7s2 .87 2 1.942v8.116zM16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm0 3.556C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444 6.873 0 12.444-5.571 12.444-12.444 0-6.873-5.571-12.444-12.444-12.444zM16 21c1.105 0 2 .707 2 1.579v.842c0 .872-.895 1.579-2 1.579s-2-.707-2-1.579v-.842c0-.872.895-1.579 2-1.579z"
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
})``

export const ArrowLeft = styled(function ArrowLeft(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="arrow-left">
      <g>
        <path
          d="m 30.179517,13.985 a -1.778,1.778 0 1 0 0,-3.555 H 1.7355173 a -1.778,1.778 0 0 0 0,3.555 z M 4.2785173,12.207 13.644517,3.05 a -1.778,1.778 0 1 0 -2.485,-2.543 L 0.49251728,10.937 a -1.778,1.778 0 0 0 0,2.542 L 11.159517,23.909 a -1.778,1.778 0 1 0 2.485,-2.543 z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const ArrowRight = styled(function ArrowRight(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="arrow-right" transform="translate(0 3)">
      <g>
        <path
          d="M1.778 13.985a1.778 1.778 0 110-3.555h28.444a1.778 1.778 0 010 3.555H1.778zm25.901-1.778L18.313 3.05A1.778 1.778 0 1120.798.507l10.667 10.43a1.778 1.778 0 010 2.542l-10.667 10.43a1.778 1.778 0 11-2.485-2.543l9.366-9.159z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Article = styled(function Article(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="article" viewBox="0 0 17 17">
      <path
        d="M.576.052a.823.823 0 0 0-.548.61C.006.766-.001 3.018.006 8.585l.008 7.778.079.16c.09.183.227.316.416.403l.128.06h15.726l.16-.079a.837.837 0 0 0 .403-.416l.06-.128V.637l-.06-.128a.837.837 0 0 0-.403-.416l-.16-.079-7.82-.006C1.093.002.716.004.576.052M15.498 8.5v6.998H1.502V1.502h13.996V8.5M3.597 4.005a.739.739 0 0 0-.289 1.292c.218.181-.034.171 4.644.171 4.199 0 4.26 0 4.41-.057.372-.139.56-.528.449-.925-.043-.152-.253-.385-.408-.452-.116-.051-.295-.053-4.399-.059-3.324-.004-4.307.003-4.407.03m-.096 3.362c-.609.239-.622 1.091-.02 1.37l.131.06h4.307c3.497 0 4.33-.007 4.431-.037.172-.052.412-.294.458-.461.105-.385-.039-.73-.38-.912l-.117-.063-4.335-.006c-4.221-.006-4.339-.004-4.475.049m.008 3.326a.74.74 0 0 0-.229 1.24c.229.207.053.196 3.038.187 2.548-.007 2.683-.01 2.777-.06a.828.828 0 0 0 .369-.408.675.675 0 0 0-.002-.529c-.069-.185-.273-.384-.445-.436-.171-.051-5.364-.046-5.508.006"
        fillRule="evenodd"
      />
    </Icon>
  )
})``

export const Bubble = styled(function Bubble(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="bubble" viewBox="0 0 34 32">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.3887 22.0074C32.4514 19.9035 33.0041 17.5708 32.9983 15.2062V14.4184C32.5695 6.59636 26.402 0.428835 18.6779 0.00270422L17.7899 5.18107e-06C15.4291 -0.00615625 13.0956 0.546514 10.9841 1.61301C5.83911 4.18438 2.58375 9.44837 2.58152 15.2077C2.57602 17.316 3.01592 19.402 3.8692 21.3275L1.09265 29.6572C0.629427 31.0468 1.9515 32.3689 3.34116 31.9057L11.6708 29.1291C13.5964 29.9824 15.6827 30.4223 17.7945 30.4168C23.5499 30.4146 28.8139 27.1592 31.3887 22.0074ZM12.587 25.6304C12.164 25.4167 11.6731 25.3808 11.2234 25.5307L5.58969 27.4086L7.46761 21.7749C7.61749 21.3252 7.5816 20.8344 7.36791 20.4113C6.55388 18.7997 6.13203 17.0186 6.13674 15.213C6.13845 10.7961 8.63282 6.76265 12.5803 4.78977C14.1986 3.97235 15.9798 3.55051 17.7853 3.55521L18.58 3.55522C24.3967 3.87883 29.1195 8.60159 29.4458 14.5163L29.4431 15.213C29.4478 17.0186 29.026 18.7997 28.2119 20.4113C26.2357 24.3655 22.2022 26.8599 17.7892 26.8616C15.9798 26.8663 14.1986 26.4445 12.587 25.6304Z"
        />
      </g>
    </Icon>
  )
})``

export const Bulb = styled(function Bulb(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="bulb" viewBox="0 0 22 32">
      <g>
        <path
          d="M11 0C4.608 0 0 5.186 0 11c0 2.773 1.028 5.303 2.723 7.237 1.04 1.187 2.67 3.675 3.276 5.76V24h3v-.007c0-.298-.045-.594-.135-.88C8.515 22 7.438 19.066 4.98 16.26A7.975 7.975 0 013.003 11C2.991 6.398 6.733 3 11 3c4.411 0 8 3.589 8 8a7.976 7.976 0 01-1.978 5.26c-2.445 2.787-3.526 5.716-3.881 6.84-.092.29-.139.591-.14.894V24h3v-.003c.606-2.085 2.237-4.573 3.277-5.76A10.945 10.945 0 0022 11c0-6.075-4.925-11-11-11zM6.004 28.699c0 .197.058.388.167.552l1.532 2.303a1 1 0 00.833.446h4.928a.999.999 0 00.832-.446l1.532-2.303c.109-.164.167-.356.168-.552l.003-2.7H6l.003 2.7zM11 5c-3.309 0-6 2.691-6 6a1 1 0 102 0c0-2.206 1.795-4 4-4a1 1 0 100-2z"
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
})``

export const BurgerMenu = styled(function BurgerMenu(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="burger-menu" viewBox="0 0 32 32">
      <path d="M1.778 17.744A1.774 1.774 0 0 1 0 15.975c0-.977.796-1.77 1.778-1.77h28.444c.982 0 1.778.793 1.778 1.77s-.796 1.77-1.778 1.77H1.778Zm0-9.578A1.774 1.774 0 0 1 0 6.396c0-.976.796-1.769 1.778-1.769h28.444c.982 0 1.778.793 1.778 1.77s-.796 1.769-1.778 1.769H1.778Zm0 19.157A1.774 1.774 0 0 1 0 25.553c0-.977.796-1.769 1.778-1.769h28.444c.982 0 1.778.793 1.778 1.77s-.796 1.769-1.778 1.769H1.778Z" />
    </Icon>
  )
})``

export const Calendar = styled(function Calendar(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="calendar">
      <g>
        <path
          d="M21 0c.828427 0 1.5.651222 1.5 1.454545V2.909l3 .000091c2.485281 0 4.5 1.953666 4.5 4.363636v20.363637C30 30.046333 27.985281 32 25.5 32h-21C2.014719 32 0 30.046333 0 27.636364V7.272727c0-2.40997 2.014719-4.363636 4.5-4.363636l3-.000091V1.454545C7.5.698476 8.094888.077141 8.85554.006658L9 0c.828427 0 1.5.651222 1.5 1.454545V2.909h9V1.454545c0-.756069.594888-1.377404 1.35554-1.447887zm6 14.545H3v13.091364c0 .803323.671573 1.454545 1.5 1.454545h21c.828427 0 1.5-.651222 1.5-1.454545V14.545zM7.5 5.818l-3 .000182c-.828427 0-1.5.651222-1.5 1.454545V11.636h24V7.272727c0-.803323-.671573-1.454545-1.5-1.454545l-3-.000182v1.454727c0 .756069-.594888 1.377405-1.35554 1.447887L21 8.727273c-.828427 0-1.5-.651222-1.5-1.454546V5.818h-9v1.454727c0 .756069-.594888 1.377405-1.35554 1.447887L9 8.727273c-.828427 0-1.5-.651222-1.5-1.454546V5.818z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Camera = styled(function Camera(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon name="camera" viewBox="0 0 54 47" {...props}>
      <g mask="url(#a)">
        <path
          clipRule="evenodd"
          d="M50.824 39.82c-.01 1.732-1.368 3.13-3.034 3.12H6.21c-1.667.01-3.025-1.388-3.034-3.12V13.574c.014-1.73 1.37-3.122 3.034-3.113h9.236a1.572 1.572 0 0 0 1.326-.735l4.145-6.424h12.166l4.153 6.424c.295.459.789.734 1.318.735h9.236c1.663-.009 3.02 1.383 3.034 3.114v26.243ZM47.79 7.16h-8.394L35.251.733A1.574 1.574 0 0 0 33.933 0H20.067a1.574 1.574 0 0 0-1.318.734L14.604 7.16H6.21C2.795 7.155.017 10.023 0 13.576v26.243c.013 3.556 2.791 6.43 6.21 6.425h41.58c3.419.005 6.197-2.869 6.21-6.425V13.575c-.017-3.552-2.794-6.42-6.21-6.416Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M28.038 33.204c-4.506 0-8.159-3.553-8.159-7.93 0-4.378 3.67-7.933 8.176-7.933 4.505 0 8.175 3.562 8.175 7.932 0 4.37-3.686 7.931-8.192 7.931Zm0-19.223c-6.3 0-11.423 5.041-11.423 11.292 0 6.25 5.123 11.292 11.423 11.292s11.423-5.041 11.423-11.292c0-6.25-5.13-11.292-11.423-11.292Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Icon>
  )
})``

export const Chain = styled(function Chain(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="chain">
      <g>
        <path
          d="M11.71 18.502a1.79 1.79 0 01.36-2.503c.79-.592 1.91-.43 2.502.36a5.36 5.36 0 008.085.58l4.267-4.27a5.368 5.368 0 00-.066-7.52c-2.068-2.07-5.411-2.1-7.496-.084l-2.46 2.446c-.7.696-1.83.693-2.527-.007a1.79 1.79 0 01.008-2.53L16.86 2.51a8.93 8.93 0 0112.526.109c3.446 3.45 3.495 9.026.087 12.557l-4.289 4.292a8.932 8.932 0 01-13.474-.966zm8.58-5.004a1.79 1.79 0 01-.36 2.503c-.79.592-1.91.43-2.502-.36a5.36 5.36 0 00-8.085-.58l-4.267 4.27a5.368 5.368 0 00.066 7.52c2.068 2.07 5.411 2.1 7.493.088l2.444-2.446a1.786 1.786 0 012.528 0 1.79 1.79 0 010 2.529L15.14 29.49a8.93 8.93 0 01-12.526-.109c-3.446-3.45-3.495-9.026-.087-12.557l4.289-4.292a8.932 8.932 0 0113.474.966z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Check = styled(function Check(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="check">
      <g transform="translate(0, 7)">
        <path
          d="M10.6666667 18.8191759L28.9651435.52069906c.6942654-.69426541 1.819892-.69426541 2.5141574 0 .6942655.6942654.6942655 1.81989203 0 2.51415744L11.9237454 22.5904121c-.6942654.6942654-1.819892.6942654-2.51415746 0L.52069906 13.7015232c-.69426541-.6942654-.69426541-1.8198921 0-2.5141575.6942654-.6942654 1.81989203-.6942654 2.51415744 0l7.6318102 7.6318102z"
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
})``

export const Checkbox = styled(function TrendingUp(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="checkbox" viewBox="0 0 32 30">
      <g>
        <path d="M28.9425 0.541901C29.624 -0.162436 30.7495 -0.182844 31.4562 0.496338C32.163 1.17552 32.1835 2.2971 31.502 3.00143L15.8575 19.1694C15.1584 19.8919 13.9972 19.8919 13.2981 19.1694L9.03137 14.7599C8.34984 14.0556 8.37032 12.9341 9.07709 12.2549C9.78386 11.5757 10.9093 11.5961 11.5908 12.3004L14.5778 15.3873L28.9425 0.541901ZM25.6 15C25.6 14.0215 26.3959 13.2283 27.3778 13.2283C28.3596 13.2283 29.1555 14.0215 29.1555 15V25.2887C29.1555 27.8765 27.1009 30 24.5333 30H4.62222C2.05468 30 0 27.8765 0 25.2887V4.71127C0 2.12343 2.05468 0 4.62222 0H20.2667C21.2485 0 22.0444 0.793211 22.0444 1.77167C22.0444 2.75012 21.2485 3.5433 20.2667 3.5433H4.62222C4.04788 3.5433 3.55554 4.05209 3.55554 4.71127V25.2887C3.55554 25.9479 4.04788 26.4567 4.62222 26.4567H24.5333C25.1077 26.4567 25.6 25.9479 25.6 25.2887V15Z" />
      </g>
    </Icon>
  )
})``

export const CheckCircle = styled(function CheckCircle(
  props: SpecificIconProps,
): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="check-circle">
      <g>
        <path
          d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-3.556c6.873 0 12.444-5.571 12.444-12.444 0-6.873-5.571-12.444-12.444-12.444C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444zm6.328-18.442a1.778 1.778 0 112.514 2.514l-10.43 10.43a1.778 1.778 0 01-2.514 0l-4.74-4.74a1.778 1.778 0 012.514-2.515l3.484 3.484 9.172-9.173z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Clock = styled(function Clock(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="clock" viewBox="0 0 18 18">
      <path
        fill="inherit"
        d="M2.63604 15.364C-0.87868 11.8492 -0.87868 6.15076 2.63604 2.63604C6.15076 -0.87868 11.8492 -0.87868 15.364 2.63604C18.8787 6.15076 18.8787 11.8492 15.364 15.364C11.8492 18.8787 6.15076 18.8787 2.63604 15.364ZM4.05025 13.9498C6.78392 16.6834 11.2161 16.6834 13.9498 13.9498C16.6834 11.2161 16.6834 6.78392 13.9498 4.05025C11.2161 1.31658 6.78392 1.31658 4.05025 4.05025C1.31658 6.78392 1.31658 11.2161 4.05025 13.9498ZM13.5191 8.56887C14.0714 8.56887 14.5191 9.01658 14.5191 9.56887C14.5191 10.1212 14.0714 10.5689 13.5191 10.5689L8.43113 10.5689C7.87884 10.5689 7.43113 10.1212 7.43113 9.56887L7.43113 5.60588C7.43113 5.0536 7.87885 4.60588 8.43113 4.60588C8.98342 4.60588 9.43113 5.0536 9.43113 5.60588L9.43113 8.56887L13.5191 8.56887Z"
      />
    </Icon>
  )
})``

export const Close = styled(function Close(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="close" viewBox="0 0 19 19">
      <g>
        <path d="M2.7464 4.1606c-.4122-.4122-.4298-1.063-.0393-1.4535.3905-.3905 1.0413-.373 1.4535.0393L16.103 14.6886c.4122.4123.4298 1.063.0392 1.4535-.3905.3906-1.0412.373-1.4535-.0392L2.7464 4.1606Z" />
        <path d="M4.1606 16.1029c-.4122.4122-1.063.4298-1.4535.0392-.3905-.3905-.373-1.0412.0393-1.4535L14.6886 2.7464c.4123-.4122 1.063-.4298 1.4535-.0393.3906.3905.373 1.0413-.0392 1.4535L4.1606 16.1029Z" />
      </g>
    </Icon>
  )
})``

export const CodeBlock = styled(function CodeBlock(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="code-block" viewBox="1 0 20 14">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M6.28 2.546L1.8 7.026l4.48 4.48M15.987 11.507l4.48-4.48-4.48-4.48M9.476 12.2207l3.0562-9.9962" />
      </g>
    </Icon>
  )
})``

export const Dollar = styled(function Dollar(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="dollar">
      <g>
        <path d="M19.83 15.585a4.164 4.164 0 0 0-2.22-1.028l-1.098-.154-.872-.131a2.178 2.178 0 0 1-1.119-.532 1.42 1.42 0 0 1-.432-1.235c.063-.463.343-.86.744-1.052a3.728 3.728 0 0 1 1.543-.34c.963.01 1.892.384 2.62 1.056.262.276.641.383.996.28.355-.103.631-.4.725-.779a1.148 1.148 0 0 0-.27-1.059 5.979 5.979 0 0 0-3.042-1.593v-.921c0-.392-.196-.754-.515-.95a.974.974 0 0 0-1.029 0 1.112 1.112 0 0 0-.514.95v.921a5.767 5.767 0 0 0-1.32.417c-1.064.49-1.814 1.533-1.981 2.756-.168 1.223.27 2.451 1.158 3.246a4.177 4.177 0 0 0 2.143 1.014l.882.135h.018l1.106.148c.427.06.83.25 1.158.548.322.287.482.731.423 1.174a1.287 1.287 0 0 1-.711 1.003 4.376 4.376 0 0 1-1.847.428 3.931 3.931 0 0 1-2.621-1.056.986.986 0 0 0-.995-.28c-.355.103-.632.4-.726.779-.094.379.01.783.27 1.059a5.979 5.979 0 0 0 3.043 1.593v.921c0 .392.196.754.514.95a.974.974 0 0 0 1.03 0c.318-.196.514-.558.514-.95v-.916a6.686 6.686 0 0 0 1.643-.529c1.037-.487 1.763-1.511 1.92-2.707.157-1.196-.277-2.394-1.148-3.166h.01Z" />
        <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16Zm0-3.555c6.873 0 12.444-5.572 12.444-12.445S22.873 3.556 16 3.556C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.445 12.444 12.445Z" />
      </g>
    </Icon>
  )
})``

export const Download = styled(function Download(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="download" viewBox="0 0 20 18">
      <g>
        <path d="M9.58484 0C10.0811 0 10.4834 0.37776 10.4834 0.84375V9.49426L13.4423 6.71588C13.7933 6.38637 14.3622 6.38637 14.7131 6.71588C15.064 7.04538 15.064 7.57962 14.7131 7.90912L10.432 11.929C9.96414 12.3683 9.20554 12.3683 8.73765 11.929L4.45656 7.90912C4.10564 7.57962 4.10564 7.04538 4.45656 6.71588C4.80747 6.38637 5.37642 6.38637 5.72734 6.71588L8.68626 9.49426V0.84375C8.68626 0.37776 9.08857 0 9.58484 0Z" />
        <path d="M1.79716 12.0938C1.79716 11.6278 1.39485 11.25 0.898579 11.25C0.402307 11.25 0 11.6278 0 12.0938V15.4688C0 16.8667 1.20692 18 2.69574 18H16.4739C17.9628 18 19.1697 16.8667 19.1697 15.4688V12.0938C19.1697 11.6278 18.7674 11.25 18.2711 11.25C17.7748 11.25 17.3725 11.6278 17.3725 12.0938V15.4688C17.3725 15.9347 16.9702 16.3125 16.4739 16.3125H2.69574C2.19947 16.3125 1.79716 15.9347 1.79716 15.4688V12.0938Z" />
      </g>
    </Icon>
  )
})``

export const Drag = styled(function Drag(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="drag" viewBox="0 0 7 12" fill="none">
      <g>
        <circle cx="1.18023" cy="1.35992" r="1.18023" fill="currentColor" />
        <circle cx="5.81988" cy="1.35992" r="1.18023" fill="currentColor" />
        <circle cx="1.18023" cy="5.99981" r="1.18023" fill="currentColor" />
        <circle cx="5.81988" cy="6.00006" r="1.18023" fill="currentColor" />
        <circle cx="1.18023" cy="10.6399" r="1.18023" fill="currentColor" />
        <circle cx="5.81988" cy="10.6399" r="1.18023" fill="currentColor" />
      </g>
    </Icon>
  )
})``

export const Edit = styled(function Edit(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="edit">
      <g>
        <path
          d="M16.937 4.419L3.632 17.829v2.953h2.93l13.305-13.41-2.93-2.953zM18.22.536l5.498 5.542a1.84 1.84 0 010 2.588L8.6 23.906c-.341.344-.803.537-1.285.537H1.816A1.823 1.823 0 010 22.613V17.07c0-.486.191-.951.532-1.295L15.652.536a1.806 1.806 0 012.569 0zM1.816 32A1.823 1.823 0 010 30.17c0-1.011.813-1.83 1.816-1.83h24.368c1.003 0 1.816.819 1.816 1.83 0 1.01-.813 1.83-1.816 1.83H1.816z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Ellipse = styled(function Ellipse(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="ellipse" viewBox="0 0 18 19">
      <circle fill="transparent" cx="9" cy="9" r="8.5" stroke="currentColor" strokeDasharray="3 3" />
    </Icon>
  )
})``

export const Ellipsis = styled(function Ellipsis(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="ellipsis" viewBox="-1 0 20 4">
      <circle cx={2} cy={2} r={2} stroke="currentColor" />
      <circle cx={9} cy={2} r={2} stroke="currentColor" />
      <circle cx={16} cy={2} r={2} stroke="currentColor" />
    </Icon>
  )
})``

export const Filter = styled(function Filter(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} fillRule="nonzero" name="filter">
      <path
        fillRule="evenodd"
        d="M11.5 25.75c0-.966.784-1.75 1.75-1.75h17a1.75 1.75 0 1 1 0 3.5h-17a1.75 1.75 0 0 1-1.75-1.75ZM0 25.623c0-.967.784-1.75 1.75-1.75h3.5a1.75 1.75 0 1 1 0 3.5h-3.5A1.75 1.75 0 0 1 0 25.623Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M9.5 27.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666ZM9.5 31a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm2-25.25c0-.966.784-1.75 1.75-1.75h17a1.75 1.75 0 1 1 0 3.5h-17a1.75 1.75 0 0 1-1.75-1.75ZM0 5.623c0-.967.784-1.75 1.75-1.75h3.5a1.75 1.75 0 1 1 0 3.5h-3.5A1.75 1.75 0 0 1 0 5.623Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M9.5 7.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666ZM9.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm11 4.25A1.75 1.75 0 0 1 18.75 17h-17a1.75 1.75 0 1 1 0-3.5h17c.966 0 1.75.784 1.75 1.75Zm11.5.127a1.75 1.75 0 0 1-1.75 1.75h-3.5a1.75 1.75 0 1 1 0-3.5h3.5c.966 0 1.75.784 1.75 1.75Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M22.5 13.667a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm0-3.667a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"
        clipRule="evenodd"
      />
    </Icon>
  )
})``

export const Hash = styled(function Hash(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="hash">
      <g>
        <text fontFamily={fonts.PRIMARY_FONT} fontWeight="bold" fontSize="40">
          <tspan x="4" y="31">
            #
          </tspan>
        </text>
      </g>
    </Icon>
  )
})``

export const Heart = styled(function Heart(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="heart">
      <g>
        <path d="M16,30a1.63,1.63,0,0,1-1.2-.49L2.71,17.57a9,9,0,0,1,0-12.87,9.34,9.34,0,0,1,13.07,0L16,4.9l.24-.22a9.3,9.3,0,0,1,13,0l.05,0h0a9.06,9.06,0,0,1,0,12.89L17.21,29.51A1.78,1.78,0,0,1,16,30ZM9.23,5.38a5.74,5.74,0,0,0-4.1,1.75,5.66,5.66,0,0,0,0,8.11h0L16,25.92,26.88,15.18a5.8,5.8,0,0,0,1.78-4.06,5.68,5.68,0,0,0-1.78-4.06h0a6,6,0,0,0-8.23,0L17.21,8.49A1.75,1.75,0,0,1,16,9h0a1.77,1.77,0,0,1-1.2-.49L13.34,7.06A5.76,5.76,0,0,0,9.23,5.38Z" />
      </g>
    </Icon>
  )
})``

export const Hourglass = styled(function Hourglass(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="hourglass" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2975 2.1875H17.5313C17.8213 2.1875 18.0995 2.07227 18.3046 1.86715C18.5098 1.66203 18.625 1.38383 18.625 1.09375C18.625 0.80367 18.5098 0.52547 18.3046 0.320352C18.0995 0.115234 17.8213 0 17.5313 0H2.34375C2.05367 0 1.77547 0.115234 1.57035 0.320352C1.36523 0.52547 1.25 0.80367 1.25 1.09375C1.25 1.38383 1.36523 1.66203 1.57035 1.86715C1.77547 2.07227 2.05367 2.1875 2.34375 2.1875H2.5751C2.42611 3.32581 2.38115 6.52378 5.96888 8.95001C6.12927 9.0657 6.25993 9.21781 6.35011 9.39382C6.44029 9.56984 6.48742 9.76474 6.48763 9.96251V10.05C6.48644 10.2467 6.43884 10.4404 6.3487 10.6152C6.25856 10.7901 6.12842 10.9412 5.96888 11.0563C2.38404 13.4805 2.42604 16.6753 2.57474 17.8125H2.34375C2.05367 17.8125 1.77547 17.9277 1.57035 18.1329C1.36523 18.338 1.25 18.6162 1.25 18.9063C1.25 19.1963 1.36523 19.4745 1.57035 19.6797C1.77547 19.8848 2.05367 20 2.34375 20H17.5313C17.8213 20 18.0995 19.8848 18.3046 19.6797C18.5098 19.4745 18.625 19.1963 18.625 18.9063C18.625 18.6162 18.5098 18.338 18.3046 18.1329C18.0995 17.9277 17.8213 17.8125 17.5313 17.8125H17.2935C17.4527 16.6978 17.5437 13.4735 13.9062 11.0313C13.745 10.915 13.6138 10.7619 13.5236 10.5847C13.4334 10.4075 13.3867 10.2113 13.3875 10.0125V9.92502C13.3897 9.72937 13.4377 9.53695 13.5278 9.36327C13.6179 9.18958 13.7475 9.03947 13.9062 8.92502C17.4681 6.51631 17.4453 3.34699 17.2975 2.1875ZM15.0792 17.8125H4.78961C4.78428 17.779 4.77738 17.7456 4.76888 17.7125C4.76262 17.6875 4.11263 14.975 7.19388 12.8875C7.65259 12.5733 8.02742 12.1515 8.28562 11.6591C8.54382 11.1667 8.67755 10.6185 8.67513 10.0625V10C8.68317 9.43777 8.55216 8.88226 8.29374 8.38286C8.03532 7.88347 7.6575 7.45567 7.19388 7.13751C4.33941 5.21893 4.70384 2.7584 4.7623 2.3637C4.76631 2.33666 4.76888 2.31932 4.76888 2.31251C4.77985 2.27129 4.78838 2.22955 4.79446 2.1875H15.0821C15.0867 2.21888 15.0927 2.25016 15.1 2.28127C15.125 2.39377 15.7125 5.06252 12.6812 7.11252C12.2225 7.42674 11.8477 7.84848 11.5895 8.34092C11.3313 8.83335 11.1976 9.38151 11.2 9.93752V10C11.192 10.5623 11.323 11.1178 11.5814 11.6172C11.8398 12.1166 12.2176 12.5444 12.6812 12.8625C15.725 14.9063 15.1312 17.5625 15.1 17.7C15.0911 17.7372 15.0841 17.7748 15.0792 17.8125ZM12.9557 4.41346C12.9051 4.38904 12.8498 4.37592 12.7936 4.375H7.08111C7.03013 4.37969 6.98059 4.39444 6.93534 4.41839C6.8901 4.44234 6.85005 4.47502 6.8175 4.51453C6.78496 4.55405 6.76057 4.59962 6.74574 4.64862C6.73091 4.69762 6.72594 4.74907 6.73111 4.8C6.91236 5.8125 8.41861 6.9375 9.31236 7.5625C9.50721 7.69073 9.73535 7.75907 9.96861 7.75907C10.2019 7.75907 10.43 7.69073 10.6249 7.5625C11.4874 6.9625 12.9936 5.8125 13.1686 4.83125C13.1786 4.77596 13.1764 4.71917 13.1623 4.6648C13.1481 4.61044 13.1223 4.5598 13.0866 4.5164C13.051 4.473 13.0063 4.43787 12.9557 4.41346Z"
      />
    </Icon>
  )
})``

export const Info = styled(function Info(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="info">
      <g>
        <path
          fillRule="evenodd"
          d="M14 14.941C14 13.87 14.895 13 16 13s2 .87 2 1.941v8.117C18 24.131 17.105 25 16 25s-2-.87-2-1.942v-8.117ZM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16Zm0-3.556c6.873 0 12.444-5.571 12.444-12.444 0-6.873-5.571-12.444-12.444-12.444C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444ZM16 11c-1.105 0-2-.707-2-1.579v-.842C14 7.707 14.895 7 16 7s2 .707 2 1.579v.842c0 .872-.895 1.579-2 1.579Z"
          clipRule="evenodd"
        />
      </g>
    </Icon>
  )
})``

export const Letter = styled(function Letter(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="letter" viewBox="3 -3 8 14">
      <g fill="currentColor" fillRule="nonzero">
        <path d="M2.022 1.351c-.255 0-.466.184-.466.406v6.486c0 .222.211.406.466.406h9.956c.255 0 .466-.184.466-.406V1.757c0-.222-.211-.406-.466-.406H2.022Zm0-1.351h9.956C13.092 0 14 .789 14 1.757v6.486C14 9.211 13.092 10 11.978 10H2.022C.908 10 0 9.211 0 8.243V1.757C0 .789.908 0 2.022 0Zm10.754 1.203c.352-.214.837-.14 1.083.166.247.306.161.727-.19.941L7.445 6.094a.875.875 0 0 1-.892 0L.332 2.31c-.352-.214-.438-.635-.191-.94.246-.306.73-.38 1.083-.167L7 4.716l5.776-3.513Z" />
      </g>
    </Icon>
  )
})``

export const Link = styled(function Link(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="link">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8998 14.6539C11.1378 15.2242 10.9822 16.3047 11.5521 17.0672C12.7499 18.6695 14.5841 19.6722 16.5787 19.8152C18.5733 19.9581 20.5316 19.2271 21.9453 17.812L25.0465 14.7088C27.6794 11.9814 27.642 7.6801 24.9835 5.01992C22.3251 2.35973 18.0265 2.32236 15.3222 4.93591L13.5262 6.72229C12.8514 7.39363 12.8482 8.48527 13.5191 9.16053C14.19 9.8358 15.281 9.83898 15.9558 9.16764L17.734 7.39871C19.0683 6.10939 21.2176 6.12808 22.5468 7.45817C23.8761 8.78826 23.8948 10.9389 22.5888 12.2919L19.5084 15.3739C18.8013 16.0817 17.8222 16.4472 16.8249 16.3758C15.8276 16.3043 14.9105 15.8029 14.3116 15.0018C13.7416 14.2393 12.6618 14.0835 11.8998 14.6539ZM18.0997 15.3461C18.8617 14.7758 19.0173 13.6953 18.4473 12.9328C17.2496 11.3305 15.4154 10.3278 13.4208 10.1848C11.4262 10.0419 9.46789 10.7729 8.05415 12.188L4.95296 15.2912C2.32008 18.0186 2.35743 22.3199 5.01592 24.9801C7.67441 27.6403 11.973 27.6776 14.6773 25.0641L16.4665 23.2742C17.1393 22.6009 17.1393 21.5092 16.4665 20.8359C15.7936 20.1626 14.7026 20.1626 14.0298 20.8359L12.262 22.6048C10.9312 23.8906 8.78187 23.8719 7.45263 22.5418C6.12338 21.2117 6.1047 19.0611 7.41065 17.7081L10.4911 14.6261C11.1982 13.9183 12.1773 13.5528 13.1746 13.6242C14.1719 13.6957 15.089 14.1971 15.6879 14.9982C16.2579 15.7607 17.3377 15.9165 18.0997 15.3461Z"
        />
      </g>
    </Icon>
  )
})``

export const Lock = styled(function Lock(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="social-facebook">
      <g>
        <path
          d="M14 0c4.6391919 0 8.4 3.90733309 8.4 8.72727273V13.09l1.4.0009091c2.3195959 0 4.2 1.9536665 4.2 4.3636364v10.1818181C28 30.0463335 26.1195959 32 23.8 32H4.2C1.88040405 32 0 30.0463335 0 27.6363636V17.4545455c0-2.4099699 1.88040405-4.3636364 4.2-4.3636364L5.6 13.09V8.72727273c0-4.73230437 3.62529469-8.5848862 8.1478416-8.72341569zm9.8 16H4.2c-.77319865 0-1.4.6512222-1.4 1.4545455v10.1818181c0 .8033233.62680135 1.4545455 1.4 1.4545455h19.6c.7731986 0 1.4-.6512222 1.4-1.4545455V17.4545455C25.2 16.6512222 24.5731986 16 23.8 16zM14 2.90909091c-3.0927946 0-5.6 2.60488873-5.6 5.81818182V13.09h11.2V8.72727273c0-3.13856535-2.3919472-5.69669516-5.3851979-5.8139805z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const MapCursor = styled(function MapCursor(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="map-cursor" viewBox="0 0 32 33">
      <g>
        <path
          d="M13.5 0C20.956 0 27 6.006 27 13.414c0 4.51-2.401 8.884-6.346 13.02a40.897 40.897 0 01-4.21 3.825 30.81 30.81 0 01-1.952 1.442 1.799 1.799 0 01-1.984 0 30.81 30.81 0 01-1.952-1.442 40.897 40.897 0 01-4.21-3.824C2.4 22.298 0 17.923 0 13.415 0 6.004 6.044 0 13.5 0zm0 3.556c-5.48 0-9.922 4.413-9.922 9.858 0 3.41 1.99 7.036 5.365 10.575a37.369 37.369 0 004.557 4.04 37.369 37.369 0 004.557-4.04c3.374-3.54 5.365-7.165 5.365-10.575 0-5.445-4.442-9.858-9.922-9.858zm0 4.202c3.144 0 5.693 2.532 5.693 5.656 0 3.124-2.549 5.657-5.693 5.657-3.144 0-5.693-2.533-5.693-5.657s2.549-5.656 5.693-5.656zm0 3.555c-1.168 0-2.114.94-2.114 2.101 0 1.16.946 2.101 2.114 2.101s2.114-.94 2.114-2.1c0-1.161-.946-2.102-2.114-2.102z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Market = styled(function Market(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="market" viewBox="0 0 22 20">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.622 5.646 12.054.949a1.462 1.462 0 0 0-2.108 0L5.378 5.646H3.035c-1.889 0-3.319 1.639-2.987 3.423L1.543 17.1c.258 1.389 1.517 2.4 2.987 2.4h12.94c1.47 0 2.729-1.011 2.987-2.4l1.495-8.031c.332-1.785-1.098-3.423-2.988-3.423h-2.342Zm-2.71 0L11 2.65 8.087 5.646h5.825ZM1.902 8.75c-.126-.677.417-1.298 1.133-1.298h15.93c.716 0 1.259.621 1.133 1.298l-1.495 8.032c-.098.526-.576.91-1.133.91H4.53c-.557 0-1.035-.384-1.133-.91L1.902 8.75Z"
        />
      </g>
    </Icon>
  )
})``

export const Media = styled(function Media(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="media" viewBox="0 0 50 47">
      <path d="M39.026 15.766c1.674.335 3.327-.76 3.662-2.434.335-1.675-.76-3.327-2.434-3.662-1.675-.335-3.328.759-3.662 2.434-.335 1.675.759 3.327 2.434 3.662ZM26.651 33.408H9.434c-.224 0-.447.045-.626.134a1.665 1.665 0 0 0-1.027 1.541c0 1.05.827 1.675 1.653 1.675h17.44c.827 0 1.452-.625 1.452-1.675s-.826-1.675-1.653-1.675h-.022Zm0-6.945H9.434c-1.027 0-1.653.625-1.653 1.675s.827 1.675 1.653 1.675h17.44c.827 0 1.452-.849 1.452-1.675 0-1.05-.826-1.675-1.653-1.675h-.022Zm.359-7.103s-.112-.022-.157-.022H16.469c-1.027 0-1.653.848-1.653 1.675 0 1.05.827 1.675 1.653 1.675h10.384c.714 0 1.25-.492 1.518-1.273.045-.134.112-.246.134-.402 0-.983-.736-1.586-1.496-1.653Z" />
      <path d="M46.618 5.56 19.35.068a3.725 3.725 0 0 0-4.399 2.926l-1.474 7.28H4.233c-2.077 0-3.73 1.674-3.73 3.774v28.16c0 2.098 1.653 3.773 3.73 3.773h27.802c2.077 0 3.73-1.675 3.73-3.774v-3.082l3.707.737a3.725 3.725 0 0 0 4.399-2.925L49.32 9.871c.603-1.988-.692-3.953-2.725-4.355l.023.045ZM32.66 40.354c0 1.474-1.027 2.523-2.501 2.523H6.109c-1.452 0-2.501-1.05-2.501-2.724V15.967c0-1.474 1.027-2.523 2.501-2.523h24.073c1.452 0 2.501 1.05 2.501 2.523v4.422m13.332-9.647-2.747 13.644c-.156.737-.156.916-.29 1.496a25.645 25.645 0 0 1-1.831-1.652l-3.864-3.774c-.402-.447-.915-.67-1.496-.737v-5.606c0-2.099-1.652-3.773-3.73-3.773H16.673l1.05-5.248c.245-1.228 1.428-1.831 2.433-1.63L44.362 8.33c1.228.245 1.831 1.429 1.63 2.434l.023-.022Z" />
    </Icon>
  )
})``

export const Megaphone = styled(function Megaphone(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="megaphone" viewBox="0 0 34 30">
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M18.469 23.227a2.36 2.36 0 0 0 1.706-.747 2.613 2.613 0 0 0 .708-1.795V3.001c0-.881-.434-1.699-1.146-2.162a2.312 2.312 0 0 0-2.35-.11L8.988 5.146H2.807c-.679 0-1.33.284-1.81.79A2.77 2.77 0 0 0 .246 7.84v8.005c0 .715.27 1.4.75 1.904.481.505 1.132.79 1.811.79h.466l1.195 8.801c.09.64.396 1.225.861 1.649a2.5 2.5 0 0 0 1.675.66h2.898c.743 0 1.45-.339 1.936-.93.487-.59.706-1.375.6-2.149l-.91-6.693 5.854 3.08c.337.178.71.27 1.087.27ZM18.371 2.79a.195.195 0 0 1 .214.01c.066.04.106.116.104.196v17.69a.221.221 0 0 1-.104.195.21.21 0 0 1-.214.01l-7.417-3.9a1.07 1.07 0 0 0-.609-.382V7.014l8.026-4.224ZM2.441 15.845V7.841c0-.213.164-.385.366-.385H8.15v8.775H2.807a.377.377 0 0 1-.366-.385Zm7.737 11.366a.357.357 0 0 1-.276.133H7.004a.374.374 0 0 1-.362-.33l-1.105-8.137h3.637l1.09 8.026a.401.401 0 0 1-.086.308ZM32.123 10.688h-4.61c-.393 0-.755.22-.951.578a1.206 1.206 0 0 0 0 1.154c.196.357.558.578.95.578h4.611c.392 0 .755-.22.95-.578a1.207 1.207 0 0 0 0-1.154 1.088 1.088 0 0 0-.95-.578ZM26.854 7.455c.217 0 .429-.067.609-.195l3.952-2.77c.246-.169.417-.433.476-.736.06-.302.001-.616-.161-.873a1.098 1.098 0 0 0-.705-.493 1.054 1.054 0 0 0-.828.18L26.245 5.34a1.196 1.196 0 0 0-.217 1.722c.209.25.51.393.826.394ZM26.243 18.346l3.952 2.77c.242.174.54.24.828.18.288-.059.542-.236.704-.493.163-.256.221-.57.162-.873a1.157 1.157 0 0 0-.476-.735l-3.952-2.77a1.051 1.051 0 0 0-1.089-.066 1.158 1.158 0 0 0-.605.954c-.027.409.155.802.476 1.033Z"
      />
    </Icon>
  )
})``

export const Menu = styled(function Menu(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="menu" viewBox="0 0 20 20">
      <g>
        <path
          d="M1 2.221C1 1.522 1.546 1 2.164 1H6.39c.619 0 1.164.522 1.164 1.221v4.337c0 .7-.545 1.222-1.164 1.222H2.164C1.546 7.78 1 7.257 1 6.558V2.221ZM1 12.944c0-.7.546-1.221 1.164-1.221H6.39c.619 0 1.164.522 1.164 1.221v4.337c0 .699-.545 1.221-1.164 1.221H2.164C1.546 18.502 1 17.98 1 17.281v-4.337ZM11.446 2.221c0-.699.545-1.221 1.164-1.221h4.226C17.454 1 18 1.522 18 2.221v4.337c0 .7-.546 1.222-1.164 1.222H12.61c-.619 0-1.164-.523-1.164-1.222V2.221ZM11.446 12.944c0-.7.545-1.221 1.164-1.221h4.226c.618 0 1.164.522 1.164 1.221v4.337c0 .699-.546 1.221-1.164 1.221H12.61c-.619 0-1.164-.522-1.164-1.221v-4.337Z"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
      </g>
    </Icon>
  )
})``

export const Minus = styled(function Minus(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="minus">
      <g transform="translate(0, 15)">
        <path
          d="M1.7778 4.2222c-.9819 0-1.7778-.8954-1.7778-2 0-1.1045.796-2 1.7778-2h28.4444c.9819 0 1.7778.8955 1.7778 2 0 1.1046-.796 2-1.7778 2H1.7778z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const News = styled(function News(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="news" viewBox="0 0 18 18">
      <g clipPath="url(#a)">
        <path d="M14.152 5.858a1.147 1.147 0 0 0 1.345-.905 1.16 1.16 0 0 0-.894-1.36 1.147 1.147 0 0 0-1.345.904 1.16 1.16 0 0 0 .894 1.36Zm-4.545 6.554H3.282a.519.519 0 0 0-.23.05.619.619 0 0 0-.377.572c0 .39.304.623.607.623H9.69c.304 0 .533-.233.533-.623a.605.605 0 0 0-.607-.622h-.008Zm0-2.58H3.282c-.377 0-.607.232-.607.622s.304.623.607.623H9.69c.304 0 .533-.316.533-.623a.605.605 0 0 0-.607-.622h-.008Zm.131-2.638s-.04-.008-.057-.008H5.866c-.377 0-.607.315-.607.622 0 .39.304.622.607.622h3.815c.262 0 .46-.182.558-.473.016-.05.04-.091.049-.15a.6.6 0 0 0-.55-.613Z" />
        <path d="M16.94 2.066 6.926.026A1.369 1.369 0 0 0 5.31 1.112l-.542 2.705H1.371C.608 3.817 0 4.439 0 5.219v10.462c0 .78.607 1.403 1.37 1.403h10.213c.763 0 1.37-.623 1.37-1.402v-1.145l1.362.273a1.37 1.37 0 0 0 1.616-1.087l2.001-10.055c.222-.739-.254-1.469-1-1.618l.008.016Zm-5.126 12.927c0 .547-.378.937-.92.937H2.06c-.533 0-.919-.39-.919-1.012V5.933c0-.548.378-.938.919-.938h8.843c.533 0 .919.39.919.938v1.642m4.897-3.584-1.009 5.07c-.057.273-.057.34-.106.555a9.435 9.435 0 0 1-.673-.614L13.511 7.6a.837.837 0 0 0-.549-.273V5.244c0-.78-.607-1.402-1.37-1.402H5.94l.386-1.95a.763.763 0 0 1 .894-.606l8.892 1.81a.771.771 0 0 1 .6.903l.007-.008Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h18v17.1H0z" />
        </clipPath>
      </defs>
    </Icon>
  )
})``

export const Euro = styled(function News(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="news" viewBox="0 0 13 15">
      <path d="M8.86059 8.08036V9.26339H5.37005C5.81756 10.8929 6.86919 11.9196 8.1222 11.9196C8.99484 11.9196 9.73322 11.4286 10.2702 10.4688L13 12.0089C11.8589 14.0625 10.2255 15 8.14458 15C5.01205 15 2.64028 12.8571 2.03614 9.26339H0V8.08036H8.86059ZM8.14458 0C10.2255 0 11.8589 0.9375 13 2.99107L10.2702 4.53125L10.2478 4.50893C9.71084 3.57143 8.97246 3.08036 8.1222 3.08036C6.91394 3.08036 5.88468 4.08482 5.4148 5.60268H8.86059V6.80804H0V5.60268H2.05852C2.7074 2.14286 5.0568 0 8.14458 0Z" />
    </Icon>
  )
})``

export const People = styled(function People(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="people" viewBox="0 0 23 18">
      <path
        clipRule="evenodd"
        d="M12 5c0-2.4-1.6-4-4-4S4 2.6 4 5s1.6 4 4 4l.155-.001.133-.004C10.528 8.904 12 7.354 12 5ZM5.5 5c0-1.572.928-2.5 2.5-2.5s2.5.928 2.5 2.5c0 1.577-.87 2.477-2.367 2.499L8 7.5c-1.572 0-2.5-.928-2.5-2.5ZM15 16.213c0-1.538-.417-2.8-1.256-3.744.683-.312 1.592-.472 2.756-.472 3.141 0 4.424 1.16 4.424 3.364 0 .353.282.639.632.639a.636.636 0 0 0 .631-.64c0-2.942-1.877-4.641-5.687-4.641-1.61 0-2.874.303-3.798.875C11.562 10.88 9.997 10.5 8 10.5c-4.69 0-7 2.09-7 5.713 0 .435.348.787.778.787.43 0 .778-.352.778-.787 0-2.711 1.578-4.14 5.444-4.14 3.866 0 5.444 1.429 5.444 4.14 0 .435.349.787.778.787.43 0 .778-.352.778-.787Zm4.75-9.963C19.75 4.3 18.45 3 16.5 3s-3.25 1.3-3.25 3.25 1.3 3.25 3.25 3.25h.126l.108-.004c1.82-.074 3.016-1.334 3.016-3.246Zm-5.281 0c0-1.277.754-2.031 2.031-2.031 1.277 0 2.031.754 2.031 2.031 0 1.28-.706 2.012-1.923 2.03l-.108.001c-1.277 0-2.031-.754-2.031-2.031Z"
        fillRule="evenodd"
      />
      <path d="m8.155 8.999.002.125h.002l-.004-.125Zm.133-.004.004.125h.001l-.005-.125ZM8.133 7.5v.125h.002L8.133 7.5ZM8 7.5v.125V7.5Zm5.744 4.97-.052-.114-.153.07.112.126.093-.083Zm-1.042-.876-.067.106.066.042.066-.042-.065-.106ZM16.626 9.5l.002.125h.002l-.004-.125Zm.108-.003.003.125h.002l-.005-.125Zm-.126-1.216v.125h.002l-.002-.125Zm-.108.001v.125-.125ZM8 1.125c1.172 0 2.138.39 2.812 1.063.673.674 1.063 1.64 1.063 2.812h.25c0-1.228-.41-2.262-1.137-2.988C10.262 1.285 9.228.875 8 .875v.25ZM4.125 5c0-1.172.39-2.138 1.063-2.812.674-.673 1.64-1.063 2.812-1.063v-.25c-1.228 0-2.262.41-2.988 1.137-.727.726-1.137 1.76-1.137 2.988h.25ZM8 8.875c-1.172 0-2.138-.39-2.812-1.063C4.515 7.138 4.125 6.172 4.125 5h-.25c0 1.228.41 2.262 1.137 2.988.726.727 1.76 1.137 2.988 1.137v-.25Zm.154-.001L8 8.875v.25l.157-.001-.003-.25Zm.13-.004-.132.004.007.25.133-.004-.007-.25ZM11.876 5c0 1.15-.36 2.094-.983 2.76-.622.667-1.518 1.066-2.61 1.11l.011.25c1.148-.047 2.109-.469 2.782-1.189.673-.72 1.05-1.728 1.05-2.931h-.25ZM8 2.375c-.81 0-1.47.24-1.928.697C5.615 3.53 5.375 4.19 5.375 5h.25c0-.761.224-1.351.624-1.751.4-.4.99-.624 1.751-.624v-.25ZM10.625 5c0-.81-.24-1.47-.697-1.928C9.47 2.615 8.81 2.375 8 2.375v.25c.761 0 1.351.224 1.75.624.4.4.625.99.625 1.751h.25Zm-2.49 2.624c.773-.012 1.4-.25 1.833-.706.433-.454.657-1.107.657-1.918h-.25c0 .766-.21 1.35-.588 1.746-.376.395-.932.617-1.656.628l.004.25ZM8 7.625l.133-.001-.002-.25-.133.001.002.25ZM5.375 5c0 .81.24 1.47.697 1.928.458.457 1.118.697 1.928.697v-.25c-.761 0-1.351-.224-1.75-.624-.4-.4-.625-.99-.625-1.751h-.25Zm8.276 7.552c.814.915 1.224 2.146 1.224 3.661h.25c0-1.561-.424-2.856-1.287-3.827l-.187.166Zm2.849-.68c-1.174 0-2.102.16-2.808.484l.104.227c.66-.302 1.55-.46 2.704-.46v-.25Zm4.549 3.489c0-1.127-.33-2.01-1.081-2.606-.746-.591-1.886-.883-3.468-.883v.25c1.56 0 2.631.29 3.312.829.675.534.987 1.333.987 2.41h.25Zm.507.514a.51.51 0 0 1-.507-.514h-.25c0 .42.337.764.757.764v-.25Zm.506-.514a.51.51 0 0 1-.506.514v.25a.76.76 0 0 0 .756-.764h-.25ZM16.5 10.844c1.889 0 3.277.421 4.192 1.188.911.764 1.37 1.885 1.37 3.329h.25c0-1.5-.479-2.7-1.46-3.52-.976-.82-2.43-1.247-4.352-1.247v.25Zm-3.732.856c.897-.555 2.136-.856 3.732-.856v-.25c-1.624 0-2.914.305-3.864.894l.132.212ZM8 10.625c1.983 0 3.522.377 4.635 1.075l.133-.212c-1.166-.731-2.757-1.113-4.768-1.113v.25Zm-6.875 5.588c0-1.783.568-3.172 1.697-4.119 1.133-.95 2.85-1.469 5.178-1.469v-.25c-2.36 0-4.144.526-5.339 1.527C1.463 12.907.875 14.374.875 16.213h.25Zm.653.662a.657.657 0 0 1-.653-.662h-.25c0 .502.403.912.903.912v-.25Zm.653-.662a.657.657 0 0 1-.653.662v.25c.5 0 .903-.41.903-.912h-.25ZM8 11.95c-1.944 0-3.34.358-4.25 1.08-.916.726-1.32 1.803-1.32 3.184h.25c0-1.33.387-2.323 1.226-2.989C4.75 12.555 6.078 12.2 8 12.2v-.25Zm5.57 4.264c0-1.38-.404-2.458-1.32-3.184-.91-.722-2.306-1.08-4.25-1.08v.25c1.922 0 3.25.355 4.095 1.026.838.665 1.224 1.658 1.224 2.988h.25Zm.652.662a.657.657 0 0 1-.653-.662h-.25c0 .502.403.912.903.912v-.25Zm.653-.662a.657.657 0 0 1-.653.662v.25c.5 0 .903-.41.903-.912h-.25ZM16.5 3.125c.947 0 1.726.315 2.268.857.542.542.857 1.321.857 2.268h.25c0-1.003-.335-1.85-.93-2.445-.596-.595-1.442-.93-2.445-.93v.25ZM13.375 6.25c0-.947.315-1.726.857-2.268.542-.542 1.321-.857 2.268-.857v-.25c-1.003 0-1.85.335-2.445.93-.595.596-.93 1.442-.93 2.445h.25ZM16.5 9.375c-.947 0-1.726-.315-2.268-.857-.542-.542-.857-1.321-.857-2.268h-.25c0 1.003.335 1.85.93 2.445.596.595 1.442.93 2.445.93v-.25Zm.124 0H16.5v.25h.128l-.004-.25Zm.107-.004-.108.003.007.25.108-.003-.008-.25Zm2.894-3.121c0 .93-.29 1.69-.792 2.227-.501.536-1.223.858-2.104.894l.01.25c.938-.038 1.725-.383 2.277-.973.551-.59.859-1.415.859-2.398h-.25ZM16.5 4.094c-.663 0-1.206.196-1.583.573-.377.377-.573.92-.573 1.583h.25c0-.614.18-1.087.5-1.406.32-.32.792-.5 1.406-.5v-.25Zm2.156 2.156c0-.663-.196-1.206-.573-1.583-.377-.377-.92-.573-1.583-.573v.25c.614 0 1.087.18 1.406.5.32.32.5.792.5 1.406h.25ZM16.61 8.405c.633-.01 1.15-.205 1.506-.58.357-.375.54-.912.54-1.575h-.25c0 .618-.17 1.087-.47 1.402-.3.316-.746.495-1.33.503l.004.25Zm-.11.001h.109l-.002-.25H16.5l.002.25ZM14.345 6.25c0 .663.196 1.206.573 1.583.377.377.92.573 1.583.573v-.25c-.614 0-1.087-.18-1.406-.5-.32-.32-.5-.792-.5-1.406h-.25Z" />
    </Icon>
  )
})``

export const Person = styled(function Person(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="person" viewBox="0 0 19 19">
      <g>
        <path d="M9.5255 11.2812c5.5833 0 8.3347 2.483 8.3347 6.7844 0 .5161-.4146.9344-.9261.9344-.5115 0-.9261-.4183-.9261-.9344 0-3.22-1.879-4.9156-6.4825-4.9156-4.6036 0-6.4826 1.6956-6.4826 4.9156 0 .5161-.4146.9344-.926.9344-.5115 0-.9262-.4183-.9262-.9344 0-4.3014 2.7515-6.7844 8.3348-6.7844ZM9.5254 0c2.8576 0 4.7627 1.9 4.7627 4.75 0 2.7952-1.7537 4.6355-4.4198 4.7442l-.1578.0044c-.0613.001-.123.0014-.1851.0014-2.8576 0-4.7627-1.9-4.7627-4.75S6.6677 0 9.5254 0Zm0 1.7813c-1.8712 0-2.9767 1.1025-2.9767 2.9687s1.1055 2.9688 2.9767 2.9688l.1582-.0012c1.7829-.0267 2.8185-1.0955 2.8185-2.9676 0-1.8662-1.1055-2.9688-2.9767-2.9688Z" />
      </g>
    </Icon>
  )
})``

export const RoundedPlus = styled(function RoundedPlus(
  props: SpecificIconProps,
): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="rounded-plus">
      <g transform="translate(.571 .571)" fillRule="nonzero">
        <path
          d="M14.714 9.714a.714.714 0 1 1 1.429 0v11.429a.714.714 0 1 1-1.429 0V9.714zm-5 6.429a.714.714 0 1 1 0-1.429h11.429a.714.714 0 1 1 0 1.429H9.714z"
          fill="currentColor"
        />
        <circle stroke="currentColor" fill="none" strokeWidth="2" cx="15.429" cy="15.429" r="15" />
      </g>
    </Icon>
  )
})``

export const Read = styled(function Read(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="read">
      <g transform="translate(0 3)">
        <path
          d="M16 0c4.506403 0 8.45159 2.176655 11.80605 5.754745 1.152448 1.229279 2.153283 2.541848 3.001503 3.855221.512491.793535.864259 1.418901 1.051683 1.793749.187685.37537.187685.8172 0 1.19257-.187424.374848-.539192 1.000214-1.051683 1.793749-.84822 1.313373-1.849055 2.625942-3.001503 3.855221C24.45159 21.823345 20.506403 24 16 24c-4.506403 0-8.45159-2.176655-11.80605-5.754745-1.152448-1.229279-2.153283-2.541848-3.001503-3.855221-.512491-.793535-.864259-1.418901-1.051683-1.793749-.187685-.37537-.187685-.8172 0-1.19257.187424-.374848.539192-1.000214 1.051683-1.793749.84822-1.313373 1.849055-2.625942 3.001503-3.855221C7.54841 2.176655 11.493597 0 16 0zm0 2.666667c-3.660263 0-6.965077 1.823345-9.860617 4.911921-1.035051 1.104055-1.940467 2.291485-2.70683 3.478113-.217517.336799-.410435.653125-.57827.943299.167835.290174.360753.6065.57827.943299.766363 1.186628 1.671779 2.374058 2.70683 3.478113C9.034923 19.509988 12.339737 21.333333 16 21.333333c3.660263 0 6.965077-1.823345 9.860617-4.911921 1.035051-1.104055 1.940467-2.291485 2.70683-3.478113.217517-.336799.410435-.653125.57827-.943299-.167835-.290174-.360753-.6065-.57827-.943299-.766363-1.186628-1.671779-2.374058-2.70683-3.478113C22.965077 4.490012 19.660263 2.666667 16 2.666667zm0 4c2.945519 0 5.333333 2.387814 5.333333 5.333333 0 2.945519-2.387814 5.333333-5.333333 5.333333-2.945519 0-5.333333-2.387814-5.333333-5.333333 0-2.945519 2.387814-5.333333 5.333333-5.333333zm0 2.666666c-1.472759 0-2.666667 1.193908-2.666667 2.666667S14.527241 14.666667 16 14.666667 18.666667 13.472759 18.666667 12 17.472759 9.333333 16 9.333333z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Refresh = styled(function Refresh(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="refresh" viewBox="0 0 18 16">
      <g>
        <path d="m.12 9.3.01-.02a.97.97 0 0 1 .14-.18l.01-.01a1 1 0 0 1 .05-.05l-.06.06a1 1 0 0 1 .14-.12.99.99 0 0 1 .59-.19h4.36c.56 0 1 .43 1 .97s-.44.97-1 .97H3.52l1.56 1.42a5.66 5.66 0 0 0 5.15 1.44 5.5 5.5 0 0 0 4-3.45 1 1 0 0 1 1.28-.59c.52.18.8.73.6 1.24a7.47 7.47 0 0 1-5.44 4.7 7.69 7.69 0 0 1-6.98-1.95L2 12v2c0 .53-.45.96-1 .96s-1-.43-1-.97V9.7v.06a.95.95 0 0 1 .11-.45ZM14.3 2.6 16 4.14V2.15c0-.53.45-.97 1-.97s1 .44 1 .97V6.45v-.07a.94.94 0 0 1-.05.31l-.03.07a.96.96 0 0 1-.2.29.97.97 0 0 1-.05.06l.06-.06a1.01 1.01 0 0 1-.73.3h-4.36c-.56 0-1-.43-1-.97 0-.53.44-.97 1-.97h1.84L12.92 4a5.66 5.66 0 0 0-5.15-1.44 5.5 5.5 0 0 0-4 3.45 1 1 0 0 1-1.28.6.96.96 0 0 1-.6-1.24A7.47 7.47 0 0 1 7.32.66a7.69 7.69 0 0 1 6.98 1.94Z" />
      </g>
    </Icon>
  )
})``

export const Reroll = styled(function Reroll(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="reroll">
      <g fillRule="nonzero">
        <path d="M32 10.64v10.72a5.963 5.963 0 0 1-5.957 5.957H14.658l2.547 2.547a.426.426 0 0 1 0 .602l-1.41 1.41a.426.426 0 0 1-.601 0l-5.68-5.68a.425.425 0 0 1 0-.601l5.68-5.68a.426.426 0 0 1 .602 0l1.409 1.41a.426.426 0 0 1 0 .602l-2.546 2.546h11.384a3.117 3.117 0 0 0 3.113-3.113V10.64a3.116 3.116 0 0 0-3.113-3.113h-.148V4.683h.148A5.966 5.966 0 0 1 32 10.64ZM5.957 27.317h.148v-2.844h-.148a3.117 3.117 0 0 1-3.113-3.113V10.64a3.116 3.116 0 0 1 3.113-3.113h11.384l-2.546 2.545a.426.426 0 0 0 0 .603l1.41 1.41a.425.425 0 0 0 .601 0l5.68-5.68a.425.425 0 0 0 0-.602L16.805.125a.425.425 0 0 0-.602 0l-1.409 1.409a.426.426 0 0 0 0 .602l2.546 2.547H5.957A5.965 5.965 0 0 0 0 10.64v10.72a5.963 5.963 0 0 0 5.957 5.957Z" />
      </g>
    </Icon>
  )
})``

export const Search = styled(function Search(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="search" viewBox="0 0 19 19">
      <g fillRule="nonzero">
        <path d="M8.2582 15.3987c-3.9436 0-7.1406-3.1969-7.1406-7.1405 0-3.9436 3.197-7.1406 7.1406-7.1406s7.1405 3.197 7.1405 7.1406-3.1969 7.1405-7.1405 7.1405Zm0-1.8628c2.9148 0 5.2777-2.3629 5.2777-5.2777 0-2.9149-2.3629-5.2778-5.2777-5.2778-2.9149 0-5.2778 2.363-5.2778 5.2778s2.363 5.2777 5.2778 5.2777Zm9.3514 2.7565c.3637.3637.3637.9534 0 1.3172-.3638.3637-.9535.3637-1.3172 0l-4.305-4.3051a.9313.9313 0 0 1 1.3171-1.3171l4.3051 4.305Z" />
      </g>
    </Icon>
  )
})``

export const Share = styled(function Share(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="share">
      <g>
        <path
          d="M21 0c3 0 6 3 6 6s-3 5-6 5l-3-1-7 4a6 6 0 010 2l7 4 3-1c3 0 6 2 6 5s-3 6-6 6a6 6 0 01-5-7l-7-4-3 2c-3 0-6-3-6-6s3-6 6-6l3 2 7-4V6c0-3 2-6 5-6zm0 22l-2 1v1c0 2 1 3 2 3 2 0 3-1 3-3 0-1-1-2-3-2zM6 13c-2 0-3 1-3 2s1 2 3 2a2 2 0 002-1 2 2 0 000-2l-2-1zM21 3c-1 0-2 1-2 3a2 2 0 000 1 2 2 0 005-1c0-2-1-3-3-3z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Shipping = styled(function Shipping(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="shipping">
      <g>
        <path
          d="M16.82061.424171L27.729572 5.83782C29.119765 6.523452 29.999176 7.930986 30 9.472451v12.898738c-.000824 1.540746-.880235 2.94828-2.267409 3.632419l-10.908572 5.413456c-.319572.158716-.65486.273417-.997137.344105-.238117.150683-.52204.238831-.826706.238831-.301479 0-.582647-.086314-.819785-.235403-.348888-.069335-.691294-.185426-1.017302-.34734l-10.91273-5.415526C.86153 25.307181-.010404 23.891106.000094 22.356937V9.471646c.001116-1.540721.880527-2.94821 2.267668-3.632332L13.179743.424171c1.146735-.565561 2.494131-.565561 3.640867 0zM2.727 9.984l.000462 12.382269c-.003542.514564.287129.986632.746323 1.216281L13.466 28.541V15.312L2.727 9.984zm24.545 0l-10.738 5.328v13.222l9.98195-4.952943c.463398-.228544.756535-.697722.75681-1.210586L27.272 9.984zM14.396384 2.846722L4.419 7.797l10.56204 5.241808c.00637-.000077.012748-.000116.019136-.000116L15.019 13.039 25.58 7.797l-9.976031-4.950278.003018.001493c-.382245-.18852-.831377-.18852-1.210603-.001493z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``

export const Star = styled(function Star(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="star">
      <g fill="transparent" stroke="currentColor" strokeWidth={3}>
        <path d="M11.615 10.463l3.707-7.515a1.25 1.25 0 0 1 2.243 0l3.71 7.514 8.295 1.213a1.25 1.25 0 0 1 .692 2.13l-6.002 5.848 1.417 8.257a1.25 1.25 0 0 1-1.814 1.317l-7.418-3.902-7.42 3.9a1.25 1.25 0 0 1-1.815-1.318l1.417-8.257-6-5.847a1.25 1.25 0 0 1 .69-2.13l8.296-1.213.002.002z" />
      </g>
    </Icon>
  )
})``

export const Stopwatch = styled(function Stopwatch(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="stopwatch" viewBox="0 0 32 33">
      <g fillRule="nonzero">
        <path d="M13 6.5a13 13 0 100 26 13 13 0 000-26zm0 3.25a9.75 9.75 0 110 19.5 9.75 9.75 0 010-19.5z" />
        <path d="M13 13c.83 0 1.52.63 1.61 1.44l.02.19v4.2l1.96 1.96c.58.58.63 1.5.13 2.14l-.13.16c-.59.58-1.51.63-2.15.13l-.15-.13-2.44-2.44a1.63 1.63 0 01-.46-.94l-.02-.21v-4.88c0-.9.73-1.62 1.63-1.62zM13 9.75c-.83 0-1.52-.63-1.61-1.44l-.02-.19v-6.5a1.63 1.63 0 013.24-.18l.02.19v6.5c0 .9-.73 1.62-1.63 1.62z" />
        <path d="M9.75 3.25A1.63 1.63 0 019.56.01L9.75 0h6.5a1.62 1.62 0 01.19 3.24l-.19.01h-6.5z" />
      </g>
    </Icon>
  )
})``

export const Tag = styled(function Tag(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="tag" viewBox="0 0 32 26">
      <>
        <path
          d="M15.57 0H1.73C.77 0 0 .77 0 1.73v13.85c0 .46.18.9.5 1.22l11.9 11.88a4.5 4.5 0 006.36 0l9.93-9.93a4.5 4.5 0 000-6.35L16.8.5c-.32-.32-.76-.5-1.22-.5zM3.47 3.46h11.39l11.38 11.39c.4.4.4 1.05 0 1.46l-9.92 9.92c-.2.2-.46.3-.74.3h-.16a1.04 1.04 0 01-.57-.3L3.46 14.86V3.46z"
          fillRule="nonzero"
        />
      </>
    </Icon>
  )
})``

export const TimesCircle = styled(function TimesCircle(
  props: SpecificIconProps,
): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="times-circle">
      <g fillRule="nonzero">
        <path d="M27.314 27.314c-6.249 6.248-16.38 6.248-22.628 0-6.248-6.249-6.248-16.38 0-22.628 6.249-6.248 16.38-6.248 22.628 0 6.248 6.249 6.248 16.38 0 22.628zM24.8 24.8c4.86-4.86 4.86-12.74 0-17.6-4.86-4.86-12.74-4.86-17.6 0-4.86 4.86-4.86 12.74 0 17.6 4.86 4.86 12.74 4.86 17.6 0z" />
        <path d="M9.767 12.281a1.778 1.778 0 112.514-2.514l9.386 9.386a1.778 1.778 0 11-2.514 2.514l-9.386-9.386zm2.514 9.386a1.778 1.778 0 11-2.514-2.514l9.386-9.386a1.778 1.778 0 112.514 2.514l-9.386 9.386z" />
      </g>
    </Icon>
  )
})``

export const Tip = styled(function Tip(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="tip">
      <g fillRule="nonzero" transform="translate(5, 6), scale(1.15)">
        <path d="M14.5 13c-.3841 0-.7567-.1268-1.056-.3592l-.036-.031-1.012-.8416-.484-.386C9.06 9.0655 7 7.386 7 4.7065 7 2.0272 9 .0002 11.568.0002c1.0876-.0109 2.1377.3832 2.932 1.1004.7926-.7173 1.8416-1.1115 2.928-1.1004 2.564 0 4.568 2.0656 4.572 4.7064 0 2.0502-1.308 3.5328-2.588 4.7103-.636.5907-1.356 1.1815-2.188 1.8648l-.144.1159c-.472.386-.976.7914-1.492 1.2277l-.036.0309c-.3002.2263-.6711.3475-1.052.3437zM11.568 1.9151C10.128 1.9152 9 3.1314 9 4.6912c0 1.7065 1.364 2.8918 4.2 5.2006l.496.4093c.26.2162.532.4362.8.6679.448-.386.884-.7336 1.292-1.0617l.136-.112c.8-.664 1.504-1.2355 2.1-1.7876 1.2-1.0926 1.972-2.0733 1.972-3.3165 0-1.5444-1.132-2.776-2.572-2.776-.8671.008-1.6642.4612-2.092 1.1892-.1854.266-.496.4252-.828.4247-.3335.0018-.6458-.1576-.832-.4247-.43-.7316-1.2326-1.1853-2.104-1.1892zM5.0146 21.2961a1.2488 1.2488 0 011.1828 0c3.3795 1.7748 5.0308 1.7785 5.6606 1.6612 0 0 5.1153-.1665 10.3688-4.9761l.4224-.4163c.3803-.3749.4604-.9536.1959-1.4152-.2086-.3605-.5622-.6172-.9735-.7066a1.5078 1.5078 0 00-1.1848.2373l-1.636.9045a26.9317 26.9317 0 00-3.122 1.9866c-1.8777 1.5265-4.5682 1.5998-6.5286.1779 2.3503.8136 4.6084.1551 5.6376-.6698.9332-.7266.8986-1.6007-.9063-1.718-2.7766-.1854-3.6368-.6812-3.9018-.9801a3.161 3.161 0 00-.8333-.6925C5.6636 12.6229 2 15.862 2 15.862l.2112.3785 2.3772 4.3517.384.6736a.0502.0502 0 00.0576.0227" />
        <path d="M2.187 16L5 21.5674 2.8633 23 0 17.2113z" />
      </g>
    </Icon>
  )
})``

export const Trash = styled(function Trash(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="trash">
      <g>
        <path d="M9.501 24.564a1.5 1.5 0 1 0 2.998-.128l-.468-11a1.5 1.5 0 0 0-2.998.128l.468 11ZM16.936 25.999a1.5 1.5 0 0 0 1.563-1.435l.468-11a1.5 1.5 0 0 0-2.998-.128l-.468 11A1.5 1.5 0 0 0 16.936 26Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 6h5.5a1.5 1.5 0 0 1 0 3h-.584l-.836 19.649A3.5 3.5 0 0 1 21.583 32H6.417a3.5 3.5 0 0 1-3.497-3.351L2.084 9H1.5a1.5 1.5 0 1 1 0-3H7V3.5A3.5 3.5 0 0 1 10.5 0h7A3.5 3.5 0 0 1 21 3.5V6ZM10.5 3a.5.5 0 0 0-.5.5V6h8V3.5a.5.5 0 0 0-.5-.5h-7ZM5.086 9l.831 19.521a.5.5 0 0 0 .5.479h15.166a.5.5 0 0 0 .5-.479L22.913 9H5.086Z"
        />
      </g>
    </Icon>
  )
})``

export const TrendingUp = styled(function TrendingUp(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="trending-up" viewBox="0 0 30 18">
      <g>
        <path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v15a1.5 1.5 0 0 0 3 0v-15A1.5 1.5 0 0 0 1.5 0Z" />
        <path d="M1.5 15a1.5 1.5 0 0 0 0 3h27a1.5 1.5 0 0 0 0-3h-27ZM28.081 1.96a1.5 1.5 0 0 1-.041 2.121l-7.8 7.5a1.5 1.5 0 0 1-2.08 0l-4.81-4.625-4.81 4.625A1.5 1.5 0 0 1 6.46 9.42l5.85-5.625a1.5 1.5 0 0 1 2.08 0l4.81 4.625 6.76-6.5a1.5 1.5 0 0 1 2.121.041Z" />
        <path d="M22.5 1.5A1.5 1.5 0 0 1 24 0h4.5A1.5 1.5 0 0 1 30 1.5V6a1.5 1.5 0 0 1-3 0V3h-3a1.5 1.5 0 0 1-1.5-1.5Z" />
      </g>
    </Icon>
  )
})``

export const Unread = styled(function Unread(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="unread">
      <g transform="translate(0 1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.520699 1.39961C-0.173566 2.09387 -0.173566 3.2195 0.520699 3.91376L5.74707 9.14013C3.50862 11.1343 1.63348 13.5092 0.211279 16.1596C-0.0618479 16.6686 -0.0706466 17.2785 0.187685 17.7952C0.376978 18.1738 0.726684 18.7955 1.23387 19.5808C2.07127 20.8774 3.05912 22.173 4.19799 23.3878C7.53424 26.9464 11.4763 29.1214 16 29.1214C18.6875 29.0776 21.2837 28.3165 23.5378 26.9309L28.9651 32.3582C29.6594 33.0525 30.785 33.0525 31.4793 32.3582C32.1736 31.6639 32.1736 30.5383 31.4793 29.844L3.03486 1.39961C2.34059 0.70534 1.21496 0.70534 0.520699 1.39961ZM10.9578 14.3509L8.26609 11.6592C6.51064 13.194 5.00855 14.998 3.81663 17.0046C3.93285 17.1979 4.06764 17.4149 4.22068 17.6518C4.94893 18.7795 5.80956 19.9081 6.7919 20.956C9.51626 23.862 12.6045 25.5658 15.9709 25.5661C17.7061 25.5377 19.4018 25.1083 20.9295 24.3225L18.6493 22.0424C17.4052 22.733 15.9243 22.9404 14.5036 22.5776C12.4994 22.0657 10.9344 20.5008 10.4226 18.4966C10.0597 17.0758 10.2672 15.595 10.9578 14.3509ZM13.8046 17.1977C13.8113 17.3376 13.8321 17.478 13.8676 17.6168C14.0577 18.3612 14.639 18.9425 15.3834 19.1326C15.5222 19.168 15.6626 19.1888 15.8025 19.1956L13.8046 17.1977ZM27.7793 16.3485C27.0511 15.2209 26.1904 14.0922 25.2081 13.0443C22.4837 10.1384 19.3955 8.4345 15.9958 8.43449C15.2196 8.43267 14.4458 8.5211 13.69 8.69801C12.734 8.92179 11.7776 8.3282 11.5539 7.3722C11.3301 6.4162 11.9237 5.45981 12.8797 5.23604C13.9038 4.99631 14.9524 4.87648 16 4.87894C20.5237 4.87894 24.4658 7.05388 27.802 10.6125C28.9409 11.8273 29.9287 13.1229 30.7661 14.4195C31.2733 15.2048 31.623 15.8265 31.8123 16.2051C32.0702 16.7209 32.0619 17.3297 31.7901 17.8382C30.9469 19.4156 29.9414 20.9007 28.7898 22.2692C28.1576 23.0205 27.0361 23.117 26.2849 22.4849C25.5336 21.8527 25.4371 20.7312 26.0692 19.98C26.8556 19.0454 27.563 18.0477 28.1844 16.9974C28.0679 16.8036 27.9328 16.5861 27.7793 16.3485Z"
        />
      </g>
    </Icon>
  )
})``

export const Sort = styled(function Sort(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} fillRule="nonzero" name="filter">
      <g>
        <path
          d="M11.8835 25.7222C11.8835 26.4279 11.2641 27 10.5 27C9.73592 27 9.11651 26.4279 9.11651 25.7222L9.1165 5.27778C9.1165 4.57208 9.73592 4 10.5 4C11.2641 4 11.8835 4.57208 11.8835 5.27778L11.8835 25.7222ZM10.5 7.10548L3.3727 13.8378C2.83852 14.3423 1.96259 14.3514 1.41627 13.8581C0.869945 13.3647 0.860103 12.5557 1.39429 12.0511L9.51079 4.38446C10.0535 3.87185 10.9465 3.87185 11.4892 4.38446L19.6057 12.0511C20.1399 12.5557 20.1301 13.3647 19.5837 13.8581C19.0374 14.3514 18.1615 14.3423 17.6273 13.8378L10.5 7.10548Z"
          stroke="currentColor"
          strokeWidth="0.6"
        />
        <path
          d="M22.1165 5.27778C22.1165 4.57208 22.7359 4 23.5 4C24.2641 4 24.8835 4.57208 24.8835 5.27778L24.8835 25.7222C24.8835 26.4279 24.2641 27 23.5 27C22.7359 27 22.1165 26.4279 22.1165 25.7222L22.1165 5.27778ZM23.5 23.8945L30.6273 17.1622C31.1615 16.6577 32.0374 16.6486 32.5837 17.1419C33.1301 17.6353 33.1399 18.4443 32.6057 18.9489L24.4892 26.6155C23.9465 27.1282 23.0535 27.1282 22.5108 26.6155L14.3943 18.9489C13.8601 18.4443 13.8699 17.6353 14.4163 17.1419C14.9626 16.6486 15.8385 16.6577 16.3727 17.1622L23.5 23.8945Z"
          stroke="currentColor"
          strokeWidth="0.6"
        />
      </g>
    </Icon>
  )
})``

export const Stack = styled(function Stack(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="stack" viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h14v14H0z" />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M6.6667.5834c1.1006 0 2.0018.8533 2.0781 1.9345l.0053.1488v.5H7.5833v-.5a.9168.9168 0 0 0-.8098-.9105l-.1069-.0061h-4a.9167.9167 0 0 0-.9105.8097l-.0061.1069v4c0 .4701.3538.8575.8097.9105l.1069.0061h.5V8.75h-.5c-1.1005 0-2.0017-.8533-2.078-1.9345l-.0052-.1488v-4c0-1.1006.8533-2.0018 1.9345-2.0781l.1488-.0052h4Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M9 2.9167c1.1006 0 2.0018.8534 2.0781 1.9345L11.0834 5v.5H9.9166V5c0-.47-.354-.8575-.8098-.9105L9 4.0834H5c-.47 0-.8575.3538-.9105.8097L4.0834 5v4c0 .47.3538.8575.8097.9105L5 9.9166h.5v1.1667H5c-1.1006 0-2.0018-.8534-2.0781-1.9345L2.9167 9V5c0-1.1006.8534-2.0018 1.9345-2.0781L5 2.9167h4Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M11.3333 5.25h-4c-1.1506 0-2.0834.9327-2.0834 2.0833v4c0 1.1506.9328 2.0834 2.0834 2.0834h4l.1488-.0053c1.0812-.0763 1.9345-.9775 1.9345-2.0781v-4c0-1.1506-.9327-2.0834-2.0833-2.0834Zm0 1.1666.107.0062a.9168.9168 0 0 1 .8096.9105v4.0002a.9165.9165 0 0 1-.9166.9164h-4a.9166.9166 0 0 1-.9167-.9166v-4a.9167.9167 0 0 1 .9167-.9167h4Z"
        />
      </g>
    </Icon>
  )
})``

export const Stop = styled(function Stop(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} name="stop" viewBox="0 0 32 32">
      <g>
        <path
          d="M27.314 4.686c6.248 6.249 6.248 16.38 0 22.628-6.249 6.248-16.38 6.248-22.628 0-6.248-6.249-6.248-16.38 0-22.628 6.249-6.248 16.38-6.248 22.628 0zm-1.596 3.54l-.147.151L8.377 25.571l-.152.147c4.887 3.92 12.043 3.613 16.575-.918 4.53-4.532 4.837-11.688.918-16.575zM7.2 7.2c-4.335 4.335-4.803 11.073-1.404 15.927l.067-.07L23.057 5.863l.07-.067C18.273 2.397 11.535 2.866 7.2 7.2z"
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
})``
